module.exports = __webpack_public_path__ + "03_short_brown.7738b2f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/mama/layer5/03_short_brown.png
// module id = jm2d
// module chunks = 0